import createReducer from '../lib/createReducer';
import setPayloadReducer from '../lib/setPayloadReducer';
import { getMode, updateUrl } from '../lib/url';

const initialState = {
  isMapUi: getMode() === 'map',
  isAbout: false,
  isLoadingScreen: !window.location.search.length,
};

const SET_MAP_UI = 'UI::MAP_UI';
const SET_ABOUT = 'UI::ABOUT';
const SET_LOADING_SCREEN = 'UI::LOADING_SCREEN';
const SET_ERROR_VISIBLE = 'UI::ERROR_VISIBLE';

/**
 * Set loading screen visible or hidden.
 * @param {!Bool} isLoadingScreen Is visible or hidden.
 * @return {object} action.
 */
export const setLoadingScreen = (isLoadingScreen) => ({
  type: SET_ABOUT,
  payload: { isLoadingScreen },
});

/**
 * Set the active ui.
 * @param {!Bool} isMapUi Is map active or not.
 * @param {bool} isUpdateUrl Should url be updated.
 * @return {object} action.
 */
export const setMapUi = (
    isMapUi,
    isUpdateUrl = true,
) => (dispatch, getState) => {
  dispatch({
    type: SET_MAP_UI,
    payload: { isMapUi },
  });

  if (!isMapUi && getState().ui.isLoadingScreen) {
    dispatch(setLoadingScreen(false));
  }

  if (isUpdateUrl) {
    updateUrl(getState());
  }
};

/**
 * Set about box visible or hidden.
 * @param {!Bool} isAbout Is about visible or hidden.
 * @return {object} action.
 */
export const setAbout = (isAbout) => ({
  type: SET_ABOUT,
  payload: { isAbout },
});

const reducer = {
  [SET_ERROR_VISIBLE]: setPayloadReducer,
  [SET_MAP_UI]: setPayloadReducer,
  [SET_ABOUT]: setPayloadReducer,
  [SET_LOADING_SCREEN]: setPayloadReducer,
};

export default createReducer(reducer, initialState);
